// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
var define;
var is_node = typeof module=='object' && module.exports;
if (is_node)
    define = require('../../../../util/require_node.js').define(module, '..');
else
    define = self.define;
define([], ()=>{
const E = {};
E.intro = [['div',
    [['h1',
        [`Cloud Office`],
        {className: `title`},
    ],
    ['p',
        [['b',
            [`Improvements? Suggestions?`],
        ],
        ` email `,
        ['a',
            [`dna@hola.org`],
            {href: `mailto:dna@hola.org`},
        ],
        ` `],
    ]],
    {className: `head`},
]];
E.data = [
    {
        id: 'cloud',
        title: `Cloud Office`,
        tag: 'h2',
        html: [['p',
            [` At Hola we managed to make it possible to work from
                everywhere!`,
            ['br'],
            ` We have invested a lot of efforts in creating the right
                environment, the right tools, and the required procedures,
                so that you would feel no difference if you work from our
                headquarters, offices, from home, or from a local Cafe. All
                you need is an Internet connection, to allow you to connect
                to our `,
            ['i',
                [`Cloud Office`],
            ],
            `.`,
            ['br'],
            ` The enhanced environment, tools, and procedures were evolved
                to compensate for the fact you are not sitting together with
                your peers in the same physical place, and to create
                conditions equivalent to working next to your peers at the
                same office. `],
        ]],
    },
    {
        id: 'cloud-login',
        title: `Login and logout`,
        tag: 'h3',
        html: [['p',
            [` While working remotely, you are requested to `,
            ['a',
                [`log in`],
                {href: `/dna/dict#attendance-report`},
            ],
            ` when starting your day of work. Once logged in, you actually
                notify everybody you are "in the office", responsive, and
                available for every incoming task.`,
            ['br'],
            ` It is sometimes unclear when you need to log out, namely: to
                distinguish between real work, for which you are required to
                be logged in, and your free time, when you should be logged
                out.`,
            ['br'],
            ` Below you can find examples for both options: `],
        ],
        ['div',
            [['ul',
                [['li',
                    [`Reading emails`],
                ],
                ['li',
                    [`Writing code`],
                ],
                ['li',
                    [`Participating in all-hands meeting`],
                ],
                ['li',
                    [`Talking to a customer`],
                ]],
            ]],
            {className: `email has-popover`,
                cat: `good`,
                'data-content': `GOOD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['div',
            [['ul',
                [['li',
                    [`Having lunch`],
                ],
                ['li',
                    [`Upgrading your laptop`],
                ],
                ['li',
                    [`Having a break that is longer than 5 minutes`],
                ]],
            ]],
            {className: `email has-popover`,
                cat: `bad`,
                'data-content': `BAD`,
                'data-original-title': ``,
                title: ``},
        ],
        ['p',
            [` While working from Hola headquarters, login and logout is used
                once you enter and leave the office. `],
        ]],
    },
    {
        id: 'cloud-morning',
        title: `Morning greeting`,
        tag: 'h3',
        html: [['p',
            [` In a regular office, once starting your working day you
                usually pass by your peers and manager and say "good
                morning". At the Cloud Office, we are using IM applications
                to do the same.`,
            ['br'],
            ` Start your day by posting "Good morning" to your manager and
                peers, so that they know you are online and started your
                day.`,
            ['br'],
            ` You can also `,
            ['a',
                [`notify`],
                {href: `/dna/comm#im-notifications`},
            ],
            ` your peers about your current status on one of the IM apps you
                are using. `],
        ]],
    },
    {
        id: 'cloud-whatnext',
        title: `What to do next?`,
        tag: 'h3',
        html: [['p',
            [`vp`],
        ]],
    },
    {
        id: 'cloud-online',
        title: `Is my peer online?`,
        tag: 'h3',
        html: [['p',
            [`contacts`],
        ]],
    },
    {
        id: 'cloud-daily',
        title: `What did I do today?`,
        tag: 'h3',
        html: [['p',
            [`daily`],
        ]],
    },
    {
        id: 'cloud-servers',
        title: `Is working remotely fast enough?`,
        tag: 'h3',
        html: [['p',
            [`servers are in the cloud`],
        ]],
    },
];
return E;
});
